import { Accordion, AccordionDetails, AccordionSummary, withStyles } from '@material-ui/core';
import React from 'react';

export const FeatureTab = withStyles(theme => ({
  root: {
    borderRadius: '0px !important',
    borderLeft: '2px solid #ccc',
    marginBottom: theme.spacing(2),
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      borderLeftColor: theme.palette.primary.main,
      marginBottom: theme.spacing(2),
    },
  },
  expanded: {},
}))(Accordion);

export const FeatureTabSummary = withStyles(theme => ({
  root: {
    minHeight: 'auto',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '&$expanded': {
      minHeight: 'auto',
    },
  },
  content: {
    margin: 0,
    '& h6': {
      fontWeight: 'bold',
    },
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},
}))(AccordionSummary);

export const FeatureTabDetails = withStyles(theme => ({
  root: {
    display: 'block',
    padding: theme.spacing(2),
    paddingTop: 0,
  },
}))(AccordionDetails);

export const FeatureTabContent = (props: { visible?: boolean; children: React.ReactNode }) => (
  <div style={{ display: props.visible ? 'block' : 'none' }}>{props.children}</div>
);
